import { render, staticRenderFns } from "./PillBadgeSample.vue?vue&type=template&id=b06a18bc&"
import script from "./PillBadgeSample.vue?vue&type=script&lang=js&"
export * from "./PillBadgeSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports